import { Strategy } from "./ancillary.js";
export function isGetterDescriptor(input) {
    return Boolean(input.get);
}
export function memoizeGetter(descriptor, propertyKey, strategy) {
    const originalFunction = descriptor.get;
    switch (strategy) {
        case Strategy.WEAKMAP: {
            const bindings = new WeakMap();
            descriptor.get = function () {
                let memoized = bindings.get(this);
                if (!memoized) {
                    memoized = originalFunction.apply(this);
                    bindings.set(this, memoized);
                }
                return memoized;
            };
            break;
        }
        case Strategy.REPLACE: {
            descriptor.get = function () {
                const value = originalFunction.apply(this);
                Object.defineProperty(this, propertyKey, {
                    configurable: false,
                    enumerable: false,
                    value: value,
                });
                return value;
            };
            break;
        }
        default:
            throw new Error(`Unsupported strategy: ${strategy}`);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0dGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2dldHRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsUUFBUSxFQUFFLE1BQU0sZ0JBQWdCLENBQUM7QUFNMUMsTUFBTSxVQUFVLGtCQUFrQixDQUNoQyxLQUFpQztJQUVqQyxPQUFPLE9BQU8sQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7QUFDNUIsQ0FBQztBQUVELE1BQU0sVUFBVSxhQUFhLENBQzNCLFVBQTRCLEVBQzVCLFdBQTRCLEVBQzVCLFFBQWtCO0lBRWxCLE1BQU0sZ0JBQWdCLEdBQUcsVUFBVSxDQUFDLEdBQUcsQ0FBQztJQUN4QyxRQUFRLFFBQVEsRUFBRTtRQUNoQixLQUFLLFFBQVEsQ0FBQyxPQUFPLENBQUMsQ0FBQztZQUNyQixNQUFNLFFBQVEsR0FBRyxJQUFJLE9BQU8sRUFBZSxDQUFDO1lBRzVDLFVBQVUsQ0FBQyxHQUFHLEdBQUc7Z0JBQ2YsSUFBSSxRQUFRLEdBQUcsUUFBUSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsQ0FBQztnQkFDbEMsSUFBSSxDQUFDLFFBQVEsRUFBRTtvQkFDYixRQUFRLEdBQUcsZ0JBQWdCLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDO29CQUN4QyxRQUFRLENBQUMsR0FBRyxDQUFDLElBQUksRUFBRSxRQUFRLENBQUMsQ0FBQztpQkFDOUI7Z0JBQ0QsT0FBTyxRQUFRLENBQUM7WUFDbEIsQ0FBQyxDQUFDO1lBQ0YsTUFBTTtTQUNQO1FBQ0QsS0FBSyxRQUFRLENBQUMsT0FBTyxDQUFDLENBQUM7WUFHckIsVUFBVSxDQUFDLEdBQUcsR0FBRztnQkFDZixNQUFNLEtBQUssR0FBRyxnQkFBZ0IsQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUM7Z0JBQzNDLE1BQU0sQ0FBQyxjQUFjLENBQUMsSUFBSSxFQUFFLFdBQVcsRUFBRTtvQkFDdkMsWUFBWSxFQUFFLEtBQUs7b0JBQ25CLFVBQVUsRUFBRSxLQUFLO29CQUNqQixLQUFLLEVBQUUsS0FBSztpQkFDYixDQUFDLENBQUM7Z0JBQ0gsT0FBTyxLQUFLLENBQUM7WUFDZixDQUFDLENBQUM7WUFDRixNQUFNO1NBQ1A7UUFDRDtZQUNFLE1BQU0sSUFBSSxLQUFLLENBQUMseUJBQXlCLFFBQVEsRUFBRSxDQUFDLENBQUM7S0FDeEQ7QUFDSCxDQUFDIn0=